export enum GRAPH_ENTITY_STATE {
    IDLE,
    ACTIVE,
    PRODUCTIVE,
}